import React, { useState, useEffect } from 'react';

const ThinkingPopup = ({ isOpen, childName, childAge, question }) => {
  const [currentMessage, setCurrentMessage] = useState('');
  const [progress, setProgress] = useState(0);

  // Messages encourageants selon l'âge
  const getEncouragingMessages = () => {
    const baseMessages = childAge <= 6 ? [
      `Ooh ! Intéressant ${childName} ! 🤔`,
      `Super question ${childName} ! ✨`,
      `Waouw ! Je réfléchis... 💭`,
      `Génial ${childName} ! Laisse-moi réfléchir !`,
      `Bonne question ! Je cherche la réponse ! 🔍`
    ] : childAge <= 10 ? [
      `Excellente question ${childName} !`,
      `Très intéressant ! Je réfléchis... ✨`,
      `Bonne question ${childName} !`,
      `Je cherche la meilleure explication pour toi !`,
      `Super ${childName} ! Je prépare ta réponse ! 📚`
    ] : [
      `Excellente question ${childName} ! 🎓`,
      `Très pertinent ! Je réfléchis...`,
      `Intéressant ${childName} !`,
      `Je prépare une explication détaillée ! 📖`,
      `Super réflexion ${childName} !`
    ];

    return baseMessages;
  };

  const getRandomMessage = () => {
    const messages = getEncouragingMessages();
    return messages[Math.floor(Math.random() * messages.length)];
  };

  // Animation de la barre de progression
  useEffect(() => {
    if (isOpen) {
      setProgress(0);
      const interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 90) return 90; // On reste à 90% jusqu'à la fin
          return prev + Math.random() * 15;
        });
      }, 800);

      return () => clearInterval(interval);
    }
  }, [isOpen]);

  // Change le message encourageant toutes les 3 secondes
  useEffect(() => {
    if (isOpen) {
      setCurrentMessage(getRandomMessage());
      
      const interval = setInterval(() => {
        setCurrentMessage(getRandomMessage());
      }, 3500);

      return () => clearInterval(interval);
    }
  }, [isOpen, childName, childAge]);

  if (!isOpen) return null;

  return (
    <>
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Caveat:wght@700&display=swap');`}
      </style>
      
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, rgba(184, 212, 227, 0.95) 0%, rgba(167, 211, 216, 0.95) 25%, rgba(158, 205, 196, 0.95) 50%, rgba(168, 213, 186, 0.95) 75%, rgba(181, 220, 174, 0.95) 100%)' }}>
        
        <div className="relative max-w-sm w-full">
          {/* Mascotte qui réfléchit */}
          <div className="absolute -top-20 left-1/2 transform -translate-x-1/2 z-10">
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_7b59aa73-04f7-469e-b3b0-3b5db031400b/artifacts/0zxv9crx_02D61451-5FF5-40EF-9C50-17F42BA59024.png"
                alt="Maman réfléchit"
                className="h-32 w-auto object-contain"
                style={{ filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.2))' }}
              />
              
              {/* Bulles de pensée */}
              <div className="absolute -top-2 right-0">
                <div className="w-3 h-3 bg-white rounded-full animate-bounce shadow-md" style={{ animationDelay: '0s' }}></div>
              </div>
              <div className="absolute -top-6 right-4">
                <div className="w-4 h-4 bg-white rounded-full animate-bounce shadow-md" style={{ animationDelay: '0.2s' }}></div>
              </div>
              <div className="absolute -top-12 right-6">
                <div className="w-6 h-6 bg-white rounded-full animate-bounce shadow-md" style={{ animationDelay: '0.4s' }}></div>
              </div>
            </div>
          </div>

          {/* Carte principale */}
          <div className="bg-white/90 backdrop-blur-md rounded-3xl p-6 pt-16 shadow-2xl border border-white/50">
            <div className="text-center">
              
              {/* Message encourageant avec police Caveat */}
              <div className="mb-5">
                <p 
                  className="text-2xl font-bold text-gray-800 mb-1"
                  style={{ fontFamily: '"Caveat", cursive' }}
                >
                  {currentMessage}
                </p>
                <p className="text-sm text-teal-600 font-medium">
                  Je prépare une réponse parfaite...
                </p>
              </div>

              {/* Barre de progression */}
              <div className="mb-5">
                <div className="w-full bg-gray-200/80 rounded-full h-3 overflow-hidden">
                  <div 
                    className="h-full rounded-full transition-all duration-500 ease-out"
                    style={{ 
                      width: `${Math.min(progress, 95)}%`,
                      background: 'linear-gradient(90deg, #3B82F6 0%, #14B8A6 100%)'
                    }}
                  ></div>
                </div>
              </div>

              {/* Question rappelée avec police Caveat */}
              {question && (
                <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 border border-teal-200/50">
                  <p 
                    className="text-sm text-teal-700 mb-1 font-medium"
                    style={{ fontFamily: '"Caveat", cursive', fontSize: '1rem' }}
                  >
                    Ta question :
                  </p>
                  <p 
                    className="text-gray-700"
                    style={{ fontFamily: '"Caveat", cursive', fontSize: '1.1rem' }}
                  >
                    "{question.length > 80 ? question.substring(0, 80) + '...' : question}"
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThinkingPopup;
